import React, { createContext, useContext, useEffect, useState } from "react";
import { getCountries } from "./api";

const CountryCtx = createContext({ countries: [], selected: null, setSelected: () => {} });

export const CountryProvider = ({ children }) => {
  const [countries, setCountries] = useState([]);
  const [selected, setSelectedState] = useState(() => localStorage.getItem("selectedCountry") || "DE");

  useEffect(() => {
    getCountries().then(setCountries).catch(() => {});
  }, []);

  const setSelected = (code) => {
    localStorage.setItem("selectedCountry", code);
    setSelectedState(code);
  };

  return (
    <CountryCtx.Provider value={{ countries, selected, setSelected }}>
      {children}
    </CountryCtx.Provider>
  );
};

export const useCountry = () => useContext(CountryCtx);
